export const mobileRegExp = /^1[3456789][0-9]{9}$/;

export const idCardRegExp = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;



// WEBPACK FOOTER //
// ./src/utils/regexp-utils.js